/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { InputProps } from "@mui/material";
import TextInputProps from "./TextInputProps";

export default class TextInputModel {
    public constructor(private readonly _props: TextInputProps) {}

    public get caption(): React.ReactNode {
        return this._props.caption;
    }

    public get name(): string | undefined {
        return this._props.name;
    }

    public get value(): string | undefined {
        return this._props.value;
    }

    public get type(): string | undefined {
        return this._props.type;
    }

    public get placeholder(): string | undefined {
        return this._props.placeholder;
    }

    public get readonly(): boolean | undefined {
        return this._props.readonly;
    }

    public get autoFocus(): boolean | undefined {
        return this._props.autoFocus;
    }

    public get required(): boolean | undefined {
        return this._props.required;
    }

    public get InputProps(): InputProps {
        return this._props.InputProps ?? {};
    }

    public get rowsMax(): number | undefined {
        return this._props.rowsMax;
    }

    public aendern = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this._props.onChange?.(e);
    };
}
